/**
 * Minicart Related Products
 * - Añade el producto al carrito vía Shopify Cart API (`/cart/add.js`).
 * - No interfiere con la apertura/cierre del cart drawer (usa stopPropagation
 *   y los botones son `type="button"` para no submitear el form padre).
 * - Tras agregar, emite `cartUpdate` del theme: el footer `MinimogCartDrawerFooter`
 *   se re-renderea con el liquid actualizado, y como el snippet filtra los
 *   productos ya presentes en el carrito, el producto desaparece de la lista.
 * - Aplica un fade-out optimista antes del re-render para una transición fluida.
 */
(function () {
    var BUTTON_SELECTOR = '[data-minicart-related-add]';
    var ITEM_SELECTOR = '[data-minicart-related-item]';
    var ROOT_SELECTOR = '[data-minicart-related]';
    var LIST_SELECTOR = '[data-minicart-related-list]';
    var PREV_SELECTOR = '[data-minicart-related-prev]';
    var NEXT_SELECTOR = '[data-minicart-related-next]';
  
    function getRoutes() {
      return (window.MinimogSettings && window.MinimogSettings.routes) || {};
    }
  
    function emitCartUpdate(response) {
      if (
        window.MinimogEvents &&
        typeof window.MinimogEvents.emit === 'function' &&
        window.MinimogTheme &&
        window.MinimogTheme.pubSubEvents
      ) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {
          cart: response,
          productVariantId: response && response.variant_id,
        });
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      }
    }
  
    function showError(message) {
      if (
        window.MinimogTheme &&
        window.MinimogTheme.Notification &&
        typeof window.MinimogTheme.Notification.show === 'function'
      ) {
        window.MinimogTheme.Notification.show({
          target: document.body,
          method: 'appendChild',
          type: 'error',
          message: message || 'No se pudo agregar el producto al carrito.',
          last: 3000,
          sticky: true,
        });
      } else {
        console.error('Minicart related:', message);
      }
    }
  
    function addToCart(variantId) {
      var routes = getRoutes();
      var addUrl = routes.cart_add_url || '/cart/add.js';
  
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
  
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      formData.append('sections', sectionsToBundle.join(','));
      formData.append('sections_url', window.location.pathname);
  
      return fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response && response.status) {
            throw new Error(response.message || response.description || 'Cart add error');
          }
          return response;
        });
    }
  
    function onAddClick(event) {
      var button = event.target.closest(BUTTON_SELECTOR);
      if (!button) return;
  
      event.preventDefault();
      event.stopPropagation();
  
      if (button.disabled || button.classList.contains('is-loading')) return;
  
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;
  
      var item = button.closest(ITEM_SELECTOR);
  
      button.classList.add('is-loading');
      button.disabled = true;
  
      addToCart(variantId)
        .then(function (response) {
          if (item) item.classList.add('is-removing');
          emitCartUpdate(response);
        })
        .catch(function (error) {
          button.classList.remove('is-loading');
          button.disabled = false;
          showError(error && error.message);
        });
    }
  
    function getStepSize(list) {
      var firstItem = list.querySelector(ITEM_SELECTOR);
      if (!firstItem) return list.clientWidth;
      var rect = firstItem.getBoundingClientRect();
      var styles = window.getComputedStyle(list);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return rect.width + gap;
    }
  
    function updateNavState(root) {
      var list = root.querySelector(LIST_SELECTOR);
      var prev = root.querySelector(PREV_SELECTOR);
      var next = root.querySelector(NEXT_SELECTOR);
      if (!list || (!prev && !next)) return;
  
      if (list.clientWidth === 0 || list.scrollWidth === 0) return;
  
      var atStart = list.scrollLeft <= 1;
      var hasOverflow = list.scrollWidth > list.clientWidth + 1;
      var atEnd = !hasOverflow || list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
  
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }
  
    function scrollByStep(root, direction) {
      var list = root.querySelector(LIST_SELECTOR);
      if (!list) return;
      var step = getStepSize(list);
      list.scrollBy({ left: direction * step, behavior: 'smooth' });
    }
  
    function initSlider(root) {
      if (!root || root.dataset.minicartRelatedReady === 'true') return;
      var list = root.querySelector(LIST_SELECTOR);
      if (!list) return;
  
      updateNavState(root);
  
      list.addEventListener('scroll', function () {
        updateNavState(root);
      });
  
      window.addEventListener('resize', function () {
        updateNavState(root);
      });
  
      if (typeof ResizeObserver === 'function') {
        var ro = new ResizeObserver(function () {
          updateNavState(root);
        });
        ro.observe(list);
      }
  
      root.dataset.minicartRelatedReady = 'true';
    }
  
    function onNavClick(event) {
      var prev = event.target.closest(PREV_SELECTOR);
      var next = event.target.closest(NEXT_SELECTOR);
      if (!prev && !next) return;
  
      event.preventDefault();
      event.stopPropagation();
  
      var root = (prev || next).closest(ROOT_SELECTOR);
      if (!root) return;
  
      scrollByStep(root, prev ? -1 : 1);
    }
  
    function initAllSliders(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      context.querySelectorAll(ROOT_SELECTOR).forEach(initSlider);
    }
  
    document.addEventListener('click', onAddClick);
    document.addEventListener('click', onNavClick);
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllSliders(document);
      });
    } else {
      initAllSliders(document);
    }
  
    document.addEventListener('shopify:section:load', function (event) {
      initAllSliders((event && event.target) || document);
    });
  
    document.addEventListener('cart:updated', function () {
      setTimeout(function () {
        initAllSliders(document);
      }, 0);
    });
  })();

/**
 * Facet product counts
 * Quita los paréntesis de `.m-facet--product-count` (p. ej. "(12)" → "12").
 */
(function () {
  var SELECTOR = '.m-facet--product-count';

  function stripFacetCountParentheses(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var nodes = [];

    if (context.matches && context.matches(SELECTOR)) {
      nodes.push(context);
    }

    context.querySelectorAll(SELECTOR).forEach(function (el) {
      nodes.push(el);
    });

    nodes.forEach(function (el) {
      var text = (el.textContent || '').trim();
      var stripped = text.replace(/[()]/g, '');
      if (text !== stripped) {
        el.textContent = stripped;
      }
    });
  }

  function init() {
    stripFacetCountParentheses(document);

    document.addEventListener('shopify:section:load', function (event) {
      stripFacetCountParentheses((event && event.target) || document);
    });

    if (typeof MutationObserver !== 'function' || !document.body) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          stripFacetCountParentheses(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  function replaceBooleanValues() {
    const specValues = document.querySelectorAll('.m-product-dropdowns__spec-value');
    
    specValues.forEach(el => {
      const text = el.textContent.trim().toLowerCase();
      if (text === 'true') {
        el.textContent = 'Sí';
      } else if (text === 'false') {
        el.textContent = 'No';
      }
    });
  }

  replaceBooleanValues();

  document.addEventListener('shopify:section:load', replaceBooleanValues);
});